import { Wasteform, Productionform, Socialform, Form } from "../../api";
import { wasteCodes, wasteKPIsCodes, wasteFormulasIndicators, convertUnitsFinal } from "./wasteForms";
import { computeRealKpiValue } from "./kpiRealValue";

const wasteController = new Wasteform();
const productionController = new Productionform();
const socialController = new Socialform();
const formController = new Form();

const CODE_TO_FIELD = Object.fromEntries(
  Object.entries(wasteKPIsCodes).map(([field, code]) => [code, field])
);

const RAW_FIELDS = Object.keys(wasteCodes);

/** Lee el valor REAL de un KPI de Residuos (sitio + año). Ver kpiRealValue.js. */
export async function getRealWasteKpiValue({ accessToken, site, kpiCode, year }) {
  const fieldKey = CODE_TO_FIELD[kpiCode];
  if (!fieldKey) return { available: false, reason: "unknown_kpi" };

  return computeRealKpiValue({
    accessToken,
    site,
    year,
    fieldKey,
    rawFields: RAW_FIELDS,
    formulasFn: wasteFormulasIndicators,
    convertFn: convertUnitsFinal,
    getRecordsFn: (t, s, ys) => wasteController.getWasteFormsByLastYears(t, s, ys),
    recordsWrapperKey: "wasteForms",
    getUnitsFn: (t, s, y, f) => wasteController.getLastUnitFieldsByYear(t, s, y, f),
    getBaselineFn: (t, s, y) => productionController.getTotalBaselineByYearAndSite(t, s, y, "standardized_production"),
    getWorkersFn: (t, s, ys) => socialController.getTotalWorkersByYears(t, s, ys),
    getConfigFn: (t, s, moduleName, active) => formController.getFormsBySite(t, s, moduleName, active),
    moduleName: "waste",
  });
}
